import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }

  // getall
  public GetAll(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/category/getall`, this.httpOptions);
  }
    public getDepartment() {
        // Create a new HttpHeaders object to avoid modifying the global headers
        const newHeaders = this.httpOptions.headers.set('lang', 'fa');
        const options = { headers: newHeaders };
        return this.http.get<any>(`${environment.apiUrl}/api/category/department`, options);
}
  public Filter(SelectdID): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/category/filter?SelectedID=` + SelectdID, this.httpOptions);
  }
  public Find(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/category/find/` + id, this.httpOptions);
  }

  // update
  // inserts
  // delete
  // find
}
